<!-- ================管理端-创建编辑协同备课====================-->
<template>
    <div class="admin-create-container">
        <div class="admin-head-container">
            <div class="admin-left-head-container" @click="backList">
                <svg t="1766639305795" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="12595" width="28" height="28"><path d="M512 512m-465.454545 0a465.454545 465.454545 0 1 0 930.90909 0 465.454545 465.454545 0 1 0-930.90909 0Z" fill="#e6e6e6" p-id="12596"></path><path d="M512 1024C229.236364 1024 0 794.763636 0 512S229.236364 0 512 0s512 229.236364 512 512-229.236364 512-512 512zM443.904 515.258182l205.637818-205.637818a58.181818 58.181818 0 1 0-82.292363-82.292364l-246.830546 246.830545a58.181818 58.181818 0 0 0 2.606546 84.712728l244.31709 244.363636a58.181818 58.181818 0 1 0 82.292364-82.292364l-205.730909-205.730909z" fill="#377f7f" p-id="12597" data-spm-anchor-id="a313x.search_index.0.i5.3a373a81dKtAXk" class="selected"></path></svg>
            </div>
            <div class="admin-right-head-container">{{!lessonId?'创建协同备课':'编辑协同备课'}}</div>
        </div>
        <div class="create-content-container">
            <el-form ref="form" :model="lessonInfo" :rules="rules" label-width="110px">
                <div class="info-content-container">
                    <div class="topic-title-container">
                        <div class="topic-title-container1">
                            <svg t="1746000464466" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="12409" width="22" height="22"><path d="M512 0.021489c-282.758945 0-511.978511 229.219565-511.978511 511.978511s229.219565 511.978511 511.978511 511.978511c282.752806 0 511.978511-229.219565 511.978511-511.978511S794.752806 0.021489 512 0.021489zM650.535193 799.341311c-30.110785 10.406001-53.770648 18.430768-71.779813 24.12035-17.759479 5.683443-38.609343 8.524141-62.269205 8.524141-36.280298 0-64.599274-8.057513-84.656075-23.679305-20.332071-16.089443-30.366611-35.953863-30.366611-60.573587 0-9.465582 0.76748-18.936281 2.297322-28.869514 1.567705-9.93221 4.121877-21.304212 7.225565-33.617655l37.547151-118.810966c3.353374-11.340279 1.453095-21.74628 3.78828-32.177863 2.316765-9.93221 3.333932-19.397792 3.333932-27.429723 0-15.647375 1.433652-26.053376-5.528923-31.742958-7.219425-6.15007-20.312628-4.383844-40.139186-4.383844-9.804297 0-19.832697 1.408069-29.854958 3.776-10.290367 2.847861-19.032472 0.607844-26.251897 3.455705l10.060123-36.926004c24.427342-8.997931 48.087205-16.562211 70.499657-22.719444 22.39301-6.617721 43.722804-9.458419 63.549362-9.458419 36.274158 0 64.09376 7.583722 83.631746 23.205515 19.551288 15.621792 41.169655 35.960003 41.169655 60.579727 0 5.215792-0.800225 14.213723-2.080382 27.461445-1.274016 12.773931-3.858888 24.613584-7.468089 35.486212L563.843762 673.880901c-2.847861 9.465582-5.65786 20.363793-7.986905 32.677237-2.585895 11.839653-3.858888 21.304212-3.858888 27.455305 0 15.621792 4.114714 26.494421 11.845793 32.184003 7.980765 5.65786 21.618367 8.498558 40.900525 8.498558 9.011234 0 19.321044-1.408069 30.878265-4.224208 11.564383-2.841721 19.800975-5.215792 24.946159-7.589862L650.535193 799.341311zM643.860167 319.355445c-17.240663 14.681374-38.315654 21.771863-62.768579 21.771863-24.434505 0-45.540196-7.090489-63.305815-21.771863-17.496489-14.213723-26.238594-31.710212-26.238594-52.547002 0-20.83679 8.742105-38.333279 26.238594-52.547002 17.765619-14.213723 38.87131-21.304212 63.305815-21.304212 24.452925 0 45.527916 7.090489 62.768579 21.304212 17.496489 14.213723 26.238594 31.710212 26.238594 52.547002 0 20.83679-8.742105 38.333279-26.238594 52.547002z" fill="#377f7f" p-id="12410"></path></svg>
                        </div>
                        <div class="topic-title-container2">基础信息</div>
                    </div>
                    <el-row>
                        <el-col :span="15">
                            <el-row>
                                <el-col :span="8">
                                    <el-form-item label="学段" prop="periodKey">
                                        <el-select style="width: 100%;" @change="changePeriod" v-model="lessonInfo.periodKey" placeholder="请选择学段">
                                            <el-option v-for="item in periodList" :key="item.dictKey" :label="item.dictValue" :value="item.dictKey" />
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="8">
                                    <el-form-item label="年级" prop="gradeKey">
                                        <el-select style="width: 100%;" @change="changeGrade" v-model="lessonInfo.gradeKey" placeholder="请选择年级">
                                            <el-option v-for="item in gradeList" :key="item.dictKey" :label="item.dictValue" :value="item.dictKey" />
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="8">
                                    <el-form-item label="学科" prop="subjectKey">
                                        <el-select style="width: 100%;" v-model="lessonInfo.subjectKey" placeholder="请选择学科">
                                            <el-option v-for="item in subjectList" :key="item.dictKey" :label="item.dictValue" :value="item.dictKey" />
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="20">
                                    <el-form-item label="备课标题" prop="title">
                                        <el-input v-model="lessonInfo.title" placeholder="最多32个字" maxlength="32" show-word-limit>
                                            <template #append>
                                                <el-icon @click="queryDirectory" class="cursor" :size="18"><Notebook /></el-icon>
                                            </template>
                                        </el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="12">
                                    <el-form-item label="课题级别" prop="lessonLevelKey">
                                        <el-select style="width: 100%;" v-model="lessonInfo.lessonLevelKey" placeholder="请选择课题级别">
                                            <el-option v-for="item in lessonLevelList" :key="item.dictKey" :label="item.dictValue" :value="item.dictKey" />
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="12">
                                    <el-form-item label="备课研讨" prop="discussMode">
                                        <el-select style="width: 100%;" v-model="lessonInfo.discussMode" placeholder="请选择备课研讨">
                                            <el-option v-for="item in discussModeList" :key="item.value" :label="item.name" :value="item.value" />
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="24">
                                    <el-form-item label="主备人" prop="leadUser">
                                        <choosePeople :showTitle="'选择主备人'" :radio="true" @gxDisable="gxDisable" ref="leadUserRef" />
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="24">
                                    <el-form-item label="协备人员" prop="teamuseList">
                                        <choosePeople :showTitle="'选择协备人员'" @gxDisable="gxDisable" ref="teamuseListRef" />
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="24">
                                    <el-form-item label="指导专家" prop="guideUsersList">
                                        <choosePeople :showTitle="'选择指导专家'" @gxDisable="gxDisable" ref="guideUsersListRef" />
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="24">
                                    <el-form-item label="备课时段" prop="formTime">
                                        <div class="time-range-container">
                                            <el-date-picker v-model="lessonInfo.beginTime" type="datetime" placeholder="开始时间" value-format="x" style="width: 220px;" />
                                            <span class="time-range-separator">至</span>
                                            <el-date-picker v-model="lessonInfo.endTime" type="datetime" placeholder="结束时间" value-format="x" style="width: 220px;" />
                                        </div>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-col>
                        <el-col :span="1"></el-col>
                        <el-col :span="8">
                            <el-form-item label="" prop="coverUrl" label-position="top">
                                <el-upload class="event-avatar-uploader"
                                           :action="serviceUrl+'/businessservice/lesson/uploadGrCover'"
                                           :show-file-list="false" :on-success="handleCoverSuccess" :headers="{ token }"
                                           :before-upload="beforeCoverUpload">
                                    <img alt="" v-if="lessonInfo.coverUrl" :src="lessonInfo.coverUrl" class="avatar" style="position:absolute" />
                                    <el-icon class="event-avatar-uploader-icon" style="font-size:100px;color:#fff;">
                                        <Plus />
                                    </el-icon>
                                </el-upload>
                                <div style="color: #a9abad;width:100%;">推荐使用540*304尺寸的图片</div>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </div>
            </el-form>
            <div class="dis-flex-row-center cus-btn">
                <el-button type="primary" @click="submitForm">保 存</el-button>
                <el-button @click="backList">取 消</el-button>
            </div>
        </div>

        <el-dialog title="课程目录" v-model="isDirectory" width="60%">
            <el-row>
                <el-empty v-if="directoryList.length == 0" style="margin: 0 auto;" description="暂无数据" />
                <div style="margin-bottom: 15px;margin-right:40px;" v-for="item in directoryList" :key="item.classId">
                    <el-card @click="goCourse(item)" class="cursor" style="width: 150px;">
                        <div class="csbbb">
                            <el-image fit="cover" style="width: 130px;height:185px" :src="item.coverUrl"></el-image>
                        </div>
                        <div class="mt5 text-one">{{ item.className }}</div>
                    </el-card>
                </div>
            </el-row>
        </el-dialog>

        <el-dialog title="课程目录" v-model="isCourse" width="60%">
            <el-table :data="tableData" :span-method="objectSpanMethod" border style="width: 100%; margin-top: 20px">
                <el-table-column prop="ptit" label="单元名" width="180">
                    <template #default="scope">
                        <div style="display: flex;justify-content: space-between;">
                            <div @click="changeTitle(scope.row)" :style="scope.row.title ? '' : 'color: #409efe;'"
                                 :class="scope.row.title ? '' : 'cursor'" :title="scope.row.ptit" style="" class="text-one ">
                                {{ scope.row.ptit }}
                            </div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="title" label="课程名">
                    <template #default="scope">
                        <div style="display: flex;justify-content: space-between;" v-if="scope.row.id">
                            <div @click="changeTitle(scope.row)" :title="scope.row.title" style="color: #409efe;"
                                 class="text-one cursor">
                                {{ scope.row.title }}
                            </div>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </el-dialog>
    </div>
</template>

<script>
import { serviceUrl } from "@/utils/global"
import { queryDict } from "@/api/admin/dict";
import { listClassLibrary, infoLibrary } from "@/api/admin/classLibrary";
import { lessonCreate, lessonUpdate, lessonInfo } from "@/api/admin/lesson";
import choosePeople from "@/components/choosePeople.vue";
import { ElLoading } from 'element-plus'

export default {
    name: "teamLessonCreate",
    components: { choosePeople },
    data() {
        return {
            serviceUrl,
            token: this.$storage.get("token"),
            lessonId: '',
            lessonInfo: {
                coverUrl: 'https://free-back.oss-cn-beijing.aliyuncs.com/ygjy/default/msyk.png',
                periodKey: '',
                gradeKey: '',
                subjectKey: '',
                title: '',
                lessonNature: '1',
                lessonLevelKey: '',
                discussMode: 1,
                leadUser: '',
                leadUserName: '',
                teamUsers: '',
                teamuseList: [],
                guideUsers: '',
                guideUsersList: [],
                beginTime: '',
                endTime: '',
            },
            periodList: [],
            gradeList: [],
            subjectList: [],
            lessonLevelList: [],
            natureList: [],
            discussModeList: [
                { name: '一轮研讨', value: 1 },
                { name: '二轮研讨', value: 2 },
            ],
            isDirectory: false,
            isCourse: false,
            directoryList: [],
            tableData: [],
            rules: {
                periodKey: [{ required: true, message: "请选择学段", trigger: "change" }],
                gradeKey: [{ required: true, message: "请选择年级", trigger: "change" }],
                subjectKey: [{ required: true, message: "请选择学科", trigger: "change" }],
                lessonNature: [{ required: true, message: "请选择备课性质", trigger: "change" }],
                lessonLevelKey: [{ required: true, message: "请选择课题级别", trigger: "change" }],
                discussMode: [{ required: true, message: "请选择备课研讨", trigger: "change" }],
                title: [{ required: true, message: "请输入备课标题", trigger: "blur" }],
                leadUser: [{ required: true, validator: this.verifyLeadUser, trigger: "change" }],
                teamuseList: [{ required: true, validator: this.verifyTeamuseList, trigger: "change" }],
                formTime: [{ required: true, validator: this.verifyFormTime, trigger: "change" }],
            }
        }
    },
    created() {
        this.getQueryDict();
        const userInfo = this.$storage.get("userInfo");
        if (userInfo) {
            try {
                const info = JSON.parse(userInfo);
                this.lessonInfo.leadUser = info.userId;
                this.lessonInfo.leadUserName = info.trueName;
            } catch (e) {
                this.lessonInfo.leadUser = '';
                this.lessonInfo.leadUserName = '';
            }
        }
    },
    mounted() {
        if (this.$route.query.lessonId) {
            this.lessonId = this.$route.query.lessonId;
            this.queryLessonInfo();
        }
    },
    methods: {
        backList() {
            this.$router.push({
                path: "/teamLesson",
            });
        },
        getQueryDict() {
            queryDict({ code: 'lession_xd_nj_xk' }).then(res => {
                this.periodList = res.data.data || [];
            })
            queryDict({ code: 'topic_level' }).then(res => {
                this.lessonLevelList = res.data.data || [];
            })
            queryDict({ code: 'activity_nature' }).then(res => {
                this.natureList = res.data.data || [];
            })
        },
        changePeriod() {
            this.lessonInfo.gradeKey = '';
            this.lessonInfo.subjectKey = '';
            this.gradeList = [];
            this.subjectList = [];
            this.periodList.forEach(j => {
                if (this.lessonInfo.periodKey == j.dictKey) {
                    this.gradeList = j.childrenList || [];
                }
            })
        },
        changeGrade() {
            this.lessonInfo.subjectKey = '';
            this.subjectList = []
            this.periodList.forEach(e => {
                if (this.lessonInfo.periodKey == e.dictKey) {
                    (e.childrenList || []).forEach(j => {
                        if (this.lessonInfo.gradeKey == j.dictKey) {
                            this.subjectList = j.childrenList || [];
                        }
                    })
                }
            })
        },
        handleCoverSuccess(response, uploadFile) {
            if (uploadFile.response.code == 1) {
                this.lessonInfo.coverUrl = uploadFile.response.data;
            } else {
                this.$message.error("上传失败")
            }
        },
        beforeCoverUpload(rawFile) {
            if (!(rawFile.type == 'image/jpeg' || rawFile.type == 'image/png' || rawFile.type == 'image/jpg')) {
                this.$message.error('图片必须是jpeg、png、jpg格式的')
                return false
            } else if (rawFile.size / 1024 / 1024 > 10) {
                this.$message.error('图片大小不能超过10M')
                return false
            }
            return true
        },
        queryDirectory() {
            listClassLibrary({
                className: '',
                periodKey: this.lessonInfo.periodKey || '',
                gradeKey: this.lessonInfo.gradeKey || '',
                subjectKey: this.lessonInfo.subjectKey || '',
            }).then(res => {
                if (res.data.code === 1) {
                    this.directoryList = JSON.parse(JSON.stringify(res.data.data || []));
                    this.isDirectory = true;
                } else {
                    this.$message.error(res.data.msg || "请求出错")
                }
            });
        },
        goCourse(item) {
            this.tableData = []
            infoLibrary({ classId: item.classId }).then(res => {
                if (res.data.code === 1) {
                    const data = res.data.data || {};
                    (data.childrenList || []).forEach(j => {
                        if (j.childrenList && j.childrenList.length) {
                            j.childrenList.forEach((m, n) => {
                                if (n == 0) {
                                    this.tableData.push({ pid: j.classId, ptit: j.className, id: m.classId, title: m.className, col: j.childrenList.length, className: data.className })
                                } else {
                                    this.tableData.push({ pid: j.classId, ptit: j.className, id: m.classId, title: m.className, col: 0, className: data.className })
                                }
                            })
                        } else {
                            this.tableData.push({ pid: j.classId, ptit: j.className, id: '', title: '', col: 1, className: data.className })
                        }
                    })
                    this.isCourse = true
                } else {
                    this.$message.error(res.data.msg || '请求出错')
                }
            })
        },
        changeTitle(row) {
            this.lessonInfo.title = row.className + '—' + row.ptit + (row.title ? '—' + row.title : '')
            this.isDirectory = false;
            this.isCourse = false;
        },
        objectSpanMethod(e) {
            if (e.columnIndex === 0) {
                if (e.row.col != 0) {
                    return {
                        rowspan: e.row.col,
                        colspan: 1,
                    }
                } else {
                    return {
                        rowspan: 0,
                        colspan: 0,
                    }
                }
            }
        },
        verifyLeadUser(rule, value, callback) {
            if (this.$refs.leadUserRef.checkList.length === 0) {
                callback(new Error('请选择主备人'))
            } else {
                callback()
            }
        },
        verifyTeamuseList(rule, value, callback) {
            if (this.$refs.teamuseListRef.checkList.length === 0) {
                callback(new Error('请选择协备人员'))
            } else {
                callback()
            }
        },
        verifyFormTime(rule, value, callback) {
            if (!this.lessonInfo.beginTime) {
                callback(new Error('请选择开始时间'))
            } else if (!this.lessonInfo.endTime) {
                callback(new Error('请选择结束时间'))
            } else if (Number(this.lessonInfo.beginTime) >= Number(this.lessonInfo.endTime)) {
                callback(new Error('结束时间必须晚于开始时间'))
            } else {
                callback()
            }
        },
        gxDisable() {
            // 主备人与协备人员互斥，指导专家不可与主备人重复
            this.$refs.leadUserRef.disabledList = [...this.$refs.teamuseListRef.checkList]
            this.$refs.teamuseListRef.disabledList = [...this.$refs.leadUserRef.checkList]
            this.$refs.guideUsersListRef.disabledList = [...this.$refs.leadUserRef.checkList]
            // 同步表单 model，触发 Element Plus 校验状态更新
            this.lessonInfo.leadUser = this.$refs.leadUserRef.checkList.length ? this.$refs.leadUserRef.checkList[0].userId : ''
            this.lessonInfo.teamuseList = this.$refs.teamuseListRef.checkList.map(e => e.userId)
            this.$forceUpdate()
            if (this.$refs.form) {
                this.$refs.form.validateField(['leadUser', 'teamuseList'])
            }
        },
        submitForm() {
            this.lessonInfo.teamuseList = [];
            this.lessonInfo.guideUsersList = [];
            this.$refs.teamuseListRef.checkList.forEach(e => {
                this.lessonInfo.teamuseList.push(e.userId)
            })
            this.$refs.guideUsersListRef.checkList.forEach(e => {
                this.lessonInfo.guideUsersList.push(e.userId)
            })
            if (this.$refs.leadUserRef.checkList.length !== 0) {
                this.lessonInfo.leadUser = this.$refs.leadUserRef.checkList[0].userId;
                this.lessonInfo.leadUserName = this.$refs.leadUserRef.checkList[0].trueName || this.$refs.leadUserRef.checkList[0].expertName || '';
            } else {
                this.lessonInfo.leadUser = '';
                this.lessonInfo.leadUserName = '';
            }
            this.lessonInfo.teamUsers = this.lessonInfo.teamuseList.toString();
            this.lessonInfo.guideUsers = this.lessonInfo.guideUsersList.toString();

            this.$refs["form"].validate(valid => {
                if (valid) {
                    const loading = ElLoading.service({ fullscreen: true })
                    var obj = JSON.parse(JSON.stringify(this.lessonInfo));
                    obj.type = 0
                    delete obj.teamuseList
                    delete obj.guideUsersList
                    if (this.lessonId) {
                        obj.lessonId = this.lessonId;
                        lessonUpdate(obj).then(res => {
                            loading.close()
                            if (res.data.code === 1) {
                                this.$message.success("保存成功");
                                this.backList();
                            } else {
                                this.$message.error(res.data.msg || "操作失败")
                            }
                        }).catch(() => {
                            loading.close()
                        })
                    } else {
                        lessonCreate(obj).then(res => {
                            loading.close()
                            if (res.data.code === 1) {
                                this.$message.success("新增成功");
                                this.backList();
                            } else {
                                this.$message.error(res.data.msg || "操作失败")
                            }
                        }).catch(() => {
                            loading.close()
                        })
                    }
                }
            });
        },
        queryLessonInfo() {
            lessonInfo({ lessonId: this.lessonId }).then(res => {
                if (res.data.code === 1) {
                    this.lessonInfo = res.data.data || {};
                    // 确保字段存在
                    if (!this.lessonInfo.lessonNature) {
                        this.lessonInfo.lessonNature = '1';
                    }
                    if (!this.lessonInfo.discussMode) {
                        this.lessonInfo.discussMode = 1;
                    }
                    // 级联数据回显
                    this.periodList.forEach(j => {
                        if (this.lessonInfo.periodKey === j.dictKey) {
                            this.gradeList = j.childrenList || [];
                        }
                    })
                    this.periodList.forEach(e => {
                        if (this.lessonInfo.periodKey === e.dictKey) {
                            (e.childrenList || []).forEach(j => {
                                if (this.lessonInfo.gradeKey === j.dictKey) {
                                    this.subjectList = j.childrenList || [];
                                }
                            })
                        }
                    })
                    // 回显人员选择
                    this.$nextTick(() => {
                        const formatUserList = (list) => {
                            if (!list || !list.length) return [];
                            return list.map(e => typeof e === 'object' ? e : { userId: e });
                        };
                        if (this.lessonInfo.leadUser) {
                            this.$refs.leadUserRef.checkList = [{
                                userId: this.lessonInfo.leadUser,
                                trueName: this.lessonInfo.leadUserName
                            }];
                        }
                        this.$refs.teamuseListRef.checkList = formatUserList(this.lessonInfo.teamUserList || this.lessonInfo.teamuseList);
                        this.$refs.guideUsersListRef.checkList = formatUserList(this.lessonInfo.guideUserList || this.lessonInfo.guideUsersList);
                    });
                } else {
                    this.$message.error(res.data.msg || "请求出错")
                }
            })
        },
    }
}
</script>

<style scoped>
.event-avatar-uploader .avatar {
    height: 152px;
    width: 270px;
    display: block;
    object-fit: cover;
}
.event-avatar-uploader /deep/ .el-upload {
    border: 1px dashed var(--el-border-color);
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    transition: var(--el-transition-duration-fast);
}
.event-avatar-uploader .el-upload:hover {
    border-color: var(--el-color-primary);
}
.el-icon.event-avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    height: 152px;
    width: 270px;
    text-align: center;
}
.info-content-container {
    width: 100%;
    height: auto;
    padding: 0 10px 0 10px;
    box-sizing: border-box;
}
.topic-title-container {
    width: 100%;
    height: 40px;
    display: flex;
}
.topic-title-container1 {
    width: 30px;
    height: 40px;
    box-sizing: border-box;
    padding-top: 10px;
}
.topic-title-container2 {
    width: 110px;
    height: 40px;
    line-height: 40px;
    font-size: 15px;
    font-weight: bold;
    color: #377f7f;
}
.time-range-container {
    display: flex;
    align-items: center;
}
.time-range-separator {
    margin: 0 10px;
    color: #606266;
}
.cus-btn {
    padding-bottom: 15px;
}
.cus-btn .el-button--primary {
    background-color: #377f7f;
    border-color: #377f7f;
}
.cursor {
    cursor: pointer;
}
</style>
